var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorTelegramIcon = function SvgColorTelegramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#color-telegram-icon_svg__a)",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8DAEA",
    d: "M9.8 17.5c-.389 0-.323-.147-.457-.517L8.2 13.221 17 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9C9DD",
    d: "M9.8 17.5c.3 0 .432-.137.6-.3l1.6-1.555-1.996-1.204"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#color-telegram-icon_svg__b)",
    d: "m10.004 14.442 4.836 3.573c.552.304.95.146 1.087-.513l1.969-9.276c.201-.808-.308-1.175-.836-.935L5.5 11.748c-.788.317-.784.757-.143.953l2.966.926 6.868-4.333c.324-.196.621-.09.377.126"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-telegram-icon_svg__a",
    x1: 9.001,
    x2: 3.001,
    y1: 1.001,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "color-telegram-icon_svg__b",
    x1: 10.498,
    x2: 11.78,
    y1: 12.738,
    y2: 16.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgColorTelegramIcon;